import { render, staticRenderFns } from "./ApiEndpointRoute.vue?vue&type=template&id=644c97ca&"
import script from "./ApiEndpointRoute.vue?vue&type=script&lang=js&"
export * from "./ApiEndpointRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports